import { render } from "./Issues.vue?vue&type=template&id=1afb4c3a&scoped=true"
import script from "./Issues.vue?vue&type=script&lang=js"
export * from "./Issues.vue?vue&type=script&lang=js"

import "./Issues.vue?vue&type=style&index=0&id=1afb4c3a&lang=scss&scoped=true"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afb4c3a"]])

export default __exports__